module.exports = function reemit(eventName, from, to) {
  if (Array.isArray(eventName)) {
    eventName.forEach(event => reemit(event, from, to));
    return;
  }

  from.on(eventName, (...args) => to.trigger(eventName, ...args));
};



// WEBPACK FOOTER //
// ./src/js/helpers/reemit.js